const createFavIconTag = () => {
  let headTitle = document.querySelector('head')
  let favIconTag = document.createElement('link')
  favIconTag.setAttribute('rel', 'shortcut icon')
  headTitle?.appendChild(favIconTag)
  return favIconTag
}

const favIconTag = () => document.querySelector(`head > link[rel='shortcut icon']`) || createFavIconTag()

export function setFaviconEmoji(emoji: string | null | undefined, defaultFavicon: string) {
  if (emoji) {
    const newImage = `
      <svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22>
          <text y=%22.9em%22 font-size=%2290%22>
          ${emoji}
        </text>
      </svg>
    `.trim()

    favIconTag().setAttribute('href', !!emoji ? `data:image/svg+xml,${newImage}` : defaultFavicon)
  }
}

export function setDefaultFaviconEmoji(favicon: string) {
  favIconTag().setAttribute('href', favicon)
}
